import Image from '@anm/components/image/Image';
import { AspectFormatProps } from '@anm/data/video-templates/aspect-dropdown';
import { useCallback, FC } from 'react';

import { DropdownItemWrapper, FormatIcon, IconBox } from './Wrapper';
import { DropDownItemProps } from './types';

export const FormatIconContainer: FC<AspectFormatProps> = ({
  icon,
  format,
  formatLabel
}) => (
  <IconBox>
    {icon?.url ? (
      <Image src={icon?.url} alt={`${format} format`} />
    ) : (
      <FormatIcon width={icon.width!} height={icon.height!}>
        {formatLabel || format}
      </FormatIcon>
    )}
  </IconBox>
);

const DropdownItem: FC<DropDownItemProps> = ({
  title,
  icon,
  index,
  format,
  formatLabel,
  aspectLabel,
  selectedIndex,
  onItemClick
}) => {
  const handleItemClick = useCallback(() => onItemClick(index, aspectLabel), [
    index,
    aspectLabel,
    onItemClick
  ]);

  const isSelected = selectedIndex === index;

  return (
    <DropdownItemWrapper {...{ isSelected }} onClick={handleItemClick}>
      <FormatIconContainer {...{ icon, format, formatLabel, title }} />
      {title}
    </DropdownItemWrapper>
  );
};

export default DropdownItem;
